var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEhSillhouettes501(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    enableBackground: "new 0 0 400 400",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#86D4D3",
    d: "M279,325h-38v-91c0-10.49,8.51-19,19-19h0c10.49,0,19,8.51,19,19V325z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#86D4D3",
    d: "M94,325H56v-22c0-10.49,8.51-19,19-19h0c10.49,0,19,8.51,19,19V325z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#86D4D3",
    d: "M344,325h-38v-22c0-10.49,8.51-19,19-19h0c10.49,0,19,8.51,19,19V325z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#86D4D3",
    d: "M221,325h-38v-22c0-10.49,8.51-19,19-19h0c10.49,0,19,8.51,19,19V325z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#86D4D3",
    d: "M163,325h-38v-96c0-10.49,8.51-19,19-19h0c10.49,0,19,8.51,19,19V325z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18.95,
    y: 324.93,
    fill: "#2F0A60",
    width: 362.11,
    height: 1.47
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F0A60",
    d: "M381.55,326.91H18.45v-2.47h363.11V326.91z M19.45,325.91h361.11v-0.47H19.45V325.91z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2F0A60",
    d: "M143.68,185.94c-31.11,0-56.43-25.31-56.43-56.42c0-31.11,25.31-56.43,56.43-56.43 c31.11,0,56.43,25.31,56.43,56.43C200.1,160.63,174.79,185.94,143.68,185.94z M143.68,75.43c-29.82,0-54.08,24.26-54.08,54.08 c0,29.82,24.26,54.08,54.08,54.08s54.08-24.26,54.08-54.08C197.76,99.7,173.5,75.43,143.68,75.43z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2F0A60",
    d: "M260.42,194.3c-24.16,0-43.82-19.66-43.82-43.82s19.66-43.82,43.82-43.82 c24.16,0,43.82,19.66,43.82,43.82S284.58,194.3,260.42,194.3z M260.42,109c-22.87,0-41.48,18.61-41.48,41.48 c0,22.87,18.61,41.48,41.48,41.48c22.87,0,41.48-18.61,41.48-41.48C301.89,127.61,283.29,109,260.42,109z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2F0A60",
    d: "M202.44,265.43c-20.86,0-37.84-16.97-37.84-37.84c0-20.86,16.97-37.84,37.84-37.84 c20.86,0,37.84,16.97,37.84,37.84C240.28,248.46,223.31,265.43,202.44,265.43z M202.44,192.1c-19.57,0-35.49,15.92-35.49,35.5 c0,19.57,15.92,35.49,35.49,35.49c19.57,0,35.49-15.92,35.49-35.49C237.94,208.02,222.01,192.1,202.44,192.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 201.27,
    y: 227.6,
    fill: "#2F0A60",
    width: 2.34,
    height: 98.08
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2F0A60",
    d: "M325.33,265.43c-20.86,0-37.84-16.97-37.84-37.84c0-20.86,16.97-37.84,37.84-37.84 c20.86,0,37.84,16.97,37.84,37.84C363.16,248.46,346.19,265.43,325.33,265.43z M325.33,192.1c-19.57,0-35.49,15.92-35.49,35.5 c0,19.57,15.92,35.49,35.49,35.49c19.57,0,35.49-15.92,35.49-35.49C360.82,208.02,344.9,192.1,325.33,192.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 324.15,
    y: 227.6,
    fill: "#2F0A60",
    width: 2.34,
    height: 98.08
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2F0A60",
    d: "M74.67,265.43c-20.86,0-37.84-16.97-37.84-37.84c0-20.86,16.97-37.84,37.84-37.84 c20.86,0,37.84,16.97,37.84,37.84C112.51,248.46,95.54,265.43,74.67,265.43z M74.67,192.1c-19.57,0-35.49,15.92-35.49,35.5 c0,19.57,15.92,35.49,35.49,35.49c19.57,0,35.49-15.92,35.49-35.49C110.17,208.02,94.25,192.1,74.67,192.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.5,
    y: 227.6,
    fill: "#2F0A60",
    width: 2.34,
    height: 98.08
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 259.25,
    y: 150.48,
    fill: "#2F0A60",
    width: 2.34,
    height: 175.19
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 142.51,
    y: 129.52,
    fill: "#2F0A60",
    width: 2.34,
    height: 196.15
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEhSillhouettes501);
export default __webpack_public_path__ + "static/media/EH Sillhouettes-5-01.09678b5cfe2f9e7211e45732f973724f.svg";
export { ForwardRef as ReactComponent };